export const globalUtils = {
    general: {
        // Hàm lấy base URL - sử dụng window.location.origin để lấy domain hiện tại
        getBaseUrl: () => {
            if (typeof window === 'undefined') return '';
            
            const { origin, pathname } = window.location;
            
            // Kiểm tra xem đang truy cập từ custom domain hay platform domain
            // Custom domain: origin khác với NEXT_PUBLIC_URL_FRONTEND (platform URL)
            // Ví dụ: ocopnghean360.com proxy đến platform.starglobal3d.com/smart-tourism-360/ocop-nghe-an
            const platformUrl = process.env.NEXT_PUBLIC_URL_FRONTEND || '';
            const platformOrigin = platformUrl ? new URL(platformUrl.startsWith('http') ? platformUrl : `https://${platformUrl}`).origin : '';
            const isCustomDomain = platformOrigin && origin !== platformOrigin;
            
            if (isCustomDomain) {
                // Custom domain: project path trong pathname là dư thừa 
                // vì domain đã map trực tiếp vào project
                // Lấy projectNamePath đã được lưu bởi IdPathProvider
                const projectNamePath = (window as any).projectNamePath || '';
                
                if (projectNamePath) {
                    const normalizedPathname = pathname.replace(/^\/+|\/+$/g, '');
                    const normalizedProjectPath = projectNamePath.replace(/^\/+|\/+$/g, '');
                    
                    if (normalizedPathname === normalizedProjectPath) {
                        // Toàn bộ pathname = project path → chỉ cần origin
                        return origin;
                    }
                    
                    if (normalizedPathname.startsWith(normalizedProjectPath + '/')) {
                        // Pathname bắt đầu bằng project path → bỏ phần project path
                        const remainingPath = normalizedPathname.slice(normalizedProjectPath.length);
                        return origin + remainingPath;
                    }
                }
                
                // Fallback cho custom domain khi chưa có projectNamePath
                return origin;
            }
            
            // Platform domain: giữ nguyên origin + pathname
            const pathParts = pathname.split('/').filter(part => part.trim() !== '');
            
            if (pathParts.length > 0) {
                const pathWithSlash = '/' + pathParts.join('/');
                return origin + pathWithSlash;
            }
            
            return origin;
        },

        autoCompleteUrl: (url: string) => {
            // if (url?.includes('http')) {
            //     return url;
            // } else {
            //     const parts = document.location.pathname.split('/');

            //     const result = `/${parts[1]}/${parts[2]}`;
            //     let baseUrl;
            //     if (document.location.origin === 'http://localhost:3002' || document.location.origin === 'https://platform.starglobal3d.com/') {
            //         baseUrl = 'https://sanpham.starglobal3d.vn' + result;
            //     } else {
            //         baseUrl = document.location.origin + result;
            //     }
            //     return baseUrl + url;
            // }

            if (url?.includes('http')) {
                return url;
            } else {
                const baseUrl = globalUtils.general.getBaseUrl();
                return baseUrl + url;
            }
        },
        viewPDF: (pdfUrl: string, element_id: string) => {},

        // Cập nhật hàm createLinkShare
        createLinkShare: (url: string) => {
            const baseUrl = globalUtils.general.getBaseUrl();
            return baseUrl + url;
        },

        // Hàm copy QR code vào clipboard dưới dạng hình ảnh
        copyQRToClipboard: async (qrRef: React.RefObject<HTMLDivElement>) => {
            if (!qrRef.current) {
                throw new Error('QR code element not found');
            }

            try {
                // Tìm canvas element từ QRCodeCanvas
                const canvas = qrRef.current.querySelector('canvas');
                if (!canvas) {
                    throw new Error('Canvas element not found in QR code');
                }

                // Đảm bảo document được focus
                window.focus();
                document.body.focus();

                // Chuyển canvas thành blob
                return new Promise<string>((resolve, reject) => {
                    canvas.toBlob(async (blob) => {
                        if (!blob) {
                            reject(new Error('Không thể tạo blob từ canvas'));
                            return;
                        }

                        try {
                            // Copy image blob vào clipboard
                            await navigator.clipboard.write([
                                new ClipboardItem({
                                    'image/png': blob,
                                }),
                            ]);
                            resolve('Đã sao chép QR code vào clipboard!');
                        } catch (error) {
                            // Fallback: Thử copy với execCommand
                            try {
                                const dataUrl = canvas.toDataURL('image/png');

                                // Tạo một element img tạm thời với safe DOM manipulation
                                const img = document.createElement('img');
                                img.src = dataUrl;
                                img.style.position = 'absolute';
                                img.style.left = '-9999px';
                                
                                let success = false;
                                try {
                                    if (document.body && document.body.appendChild) {
                                        document.body.appendChild(img);
                                    } else {
                                        throw new Error('Document body not available');
                                    }

                                    // Select và copy
                                    const range = document.createRange();
                                    range.selectNode(img);
                                    window.getSelection()?.removeAllRanges();
                                    window.getSelection()?.addRange(range);

                                    success = document.execCommand('copy');
                                    
                                    // Safe removal
                                    if (document.body && img.parentNode === document.body) {
                                        document.body.removeChild(img);
                                    }
                                } catch (domError) {
                                    // Clean up if still exists
                                    if (img.parentNode) {
                                        img.parentNode.removeChild(img);
                                    }
                                    throw domError;
                                }

                                if (success) {
                                    resolve('Đã sao chép QR code vào clipboard!');
                                } else {
                                    reject(new Error('Không thể sao chép QR code'));
                                }
                            } catch (fallbackError) {
                                reject(new Error(`Không thể sao chép QR code: ${error}`));
                            }
                        }
                    }, 'image/png');
                });
            } catch (error) {
                throw new Error(`Lỗi khi sao chép QR code: ${error}`);
            }
        },

        // Hàm tải QR code xuống
        downloadQRCode: (qrRef: React.RefObject<HTMLDivElement>, fileName: string = 'qr-code.png') => {
            if (!qrRef.current) {
                throw new Error('QR code element not found');
            }

            try {
                // Tìm canvas element từ QRCodeCanvas
                const canvas = qrRef.current.querySelector('canvas');
                if (!canvas) {
                    throw new Error('Canvas element not found in QR code');
                }

                // Tạo link download với safe DOM manipulation
                const link = document.createElement('a');
                link.download = fileName;
                link.href = canvas.toDataURL('image/png');
                
                try {
                    if (document.body && document.body.appendChild) {
                        document.body.appendChild(link);
                        link.click();
                        
                        // Safe removal
                        if (document.body && link.parentNode === document.body) {
                            document.body.removeChild(link);
                        }
                    } else {
                        // Fallback: trigger download without appending to DOM
                        link.click();
                    }
                } catch (domError) {
                    // Clean up if still exists
                    if (link.parentNode) {
                        link.parentNode.removeChild(link);
                    }
                    throw new Error(`DOM manipulation error: ${domError}`);
                }
            } catch (error) {
                throw new Error(`Không thể tải xuống QR code: ${error}`);
            }
        },

        // Hàm copy text vào clipboard với fallback an toàn
        copyTextToClipboard: async (text: string) => {
            try {
                if (typeof navigator !== 'undefined' && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
                    await navigator.clipboard.writeText(text);
                    return;
                }
                throw new Error('Clipboard API not available');
            } catch (error) {
                try {
                    const textArea = document.createElement('textarea');
                    textArea.value = text;
                    textArea.style.position = 'fixed';
                    textArea.style.left = '-9999px';
                    textArea.style.top = '-9999px';
                    textArea.style.opacity = '0';
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    const successful = document.execCommand('copy');
                    document.body.removeChild(textArea);
                    if (!successful) throw new Error('execCommand copy failed');
                } catch (fallbackError) {
                    throw new Error(`Không thể sao chép text: ${error}`);
                }
            }
        },

        // Cập nhật hàm shareOnZalo
        shareOnZalo: (url: string) => {
            const baseUrl = globalUtils.general.getBaseUrl();
            return baseUrl + url;
        },


        // Hàm chia sẻ trên Facebook
        shareOnFacebook: (url: string) => {
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank', 'left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
        },

        // Hàm chia sẻ trên Zalo
        shareOnZaloSocial: (url: string) => {
            const zaloUrl = `https://zalo.me/share?url=${encodeURIComponent(url)}`;
            window.open(zaloUrl, '_blank');
        },

        // Hàm chia sẻ trên WhatsApp
        shareOnWhatsapp: (url: string) => {
            const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`;
            window.open(whatsappUrl, '_blank');
            // return 'Đã mở WhatsApp để chia sẻ!';
        },

        // Hàm chia sẻ trên Telegram
        shareOnTelegram: (url: string) => {
            const telegramUrl = `https://telegram.me/share/url?url=${encodeURIComponent(url)}`;
            window.open(telegramUrl, '_blank');
        },

        // Hàm chia sẻ trên LinkedIn
        shareOnLinkedin: (url: string) => {
            const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
            window.open(linkedinUrl, '_blank');
        },

        // Hàm chia sẻ trên X (Twitter)
        shareOnX: (url: string) => {
            const twitterUrl = `http://twitter.com/share?url=${encodeURIComponent(url)}`;
            window.open(twitterUrl, '_blank');
        },

        // Hàm chia sẻ trên Messenger
        shareOnMessenger: (url: string) => {
            const isMobile = typeof window !== 'undefined' && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
            if (isMobile) {
                window.location.href = `fb-messenger://share/?link=${encodeURIComponent(url)}`;
                return;
            }
            const fbAppId = (typeof process !== 'undefined' && process.env?.NEXT_PUBLIC_FACEBOOK_APP_ID) || '626676790016199';
            const redirectUri = (url && !url.includes('localhost')) ? url : 'https://starglobal3d.com';
            const messengerUrl = `https://www.facebook.com/dialog/send?link=${encodeURIComponent(url)}&app_id=${fbAppId}&redirect_uri=${encodeURIComponent(redirectUri)}`;
            window.open(messengerUrl, '_blank', 'left=100,top=100,width=650,height=550,personalbar=0,toolbar=0,scrollbars=1,resizable=1');
        },

        // Hàm hiển thị toast notification với status
        showToast: (message: string, title: string = 'Notification', status: 'success' | 'error' | 'warning' | 'info' = 'info', autohide: boolean = true, delay: number = 5000) => {
            let toastContainer = document.getElementById('toast-container');
            
            // Check if the toast container exists, if not create it and append to the body
            if (!toastContainer) {
                toastContainer = document.createElement('div');
                toastContainer.id = 'toast-container';
                toastContainer.style.cssText = `
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    z-index: 999999999999;
                    display: block;
                `;
                document.body.appendChild(toastContainer);
            }
            
            toastContainer.style.display = "block";
            
            const toastElement = document.createElement('div');
            toastElement.setAttribute('role', 'alert');
            toastElement.setAttribute('aria-live', 'assertive');
            toastElement.setAttribute('aria-atomic', 'true');
            
            // Định nghĩa style và icon theo status
            const getStatusConfig = (status: string) => {
                switch (status) {
                    case 'success':
                        return {
                            bgColor: 'background-color: #d4edda; border-color: #c3e6cb; color: #155724;',
                            icon: '✓',
                            iconColor: '#28a745'
                        };
                    case 'error':
                        return {
                            bgColor: 'background-color: #f8d7da; border-color: #f5c6cb; color: #721c24;',
                            icon: '✗',
                            iconColor: '#dc3545'
                        };
                    case 'warning':
                        return {
                            bgColor: 'background-color: #fff3cd; border-color: #ffeaa7; color: #856404;',
                            icon: '⚠',
                            iconColor: '#ffc107'
                        };
                    case 'info':
                    default:
                        return {
                            bgColor: 'background-color: #d1ecf1; border-color: #bee5eb; color: #0c5460;',
                            icon: 'ℹ',
                            iconColor: '#17a2b8'
                        };
                }
            };

            const config = getStatusConfig(status);
            
            toastElement.style.cssText = `
                ${config.bgColor}
                border: 1px solid;
                border-radius: 8px;
                padding: 12px 16px;
                margin-bottom: 10px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                min-width: 300px;
                max-width: 400px;
                opacity: 0;
                transform: translateX(100%);
                transition: all 0.3s ease;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                font-size: 14px;
                line-height: 1.4;
            `;

            const escapeHtml = (str: string) => {
                return String(str).replace(/[&<>"']/g, (s) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[s] || s));
            };

            toastElement.innerHTML = `
                <div style="display: flex; align-items: flex-start; gap: 10px;">
                    <span style="color: ${config.iconColor}; font-size: 16px; font-weight: bold; flex-shrink: 0;">
                        ${config.icon}
                    </span>
                    <div style="flex: 1; min-width: 0;">
                        <div style="font-weight: 600; margin-bottom: 4px;">${escapeHtml(title)}</div>
                        <div style="word-wrap: break-word;">${escapeHtml(message)}</div>
                    </div>
                    <button type="button" style="
                        background: none;
                        border: none;
                        font-size: 18px;
                        cursor: pointer;
                        color: currentColor;
                        opacity: 0.6;
                        padding: 0;
                        width: 20px;
                        height: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                    " aria-label="Close">×</button>
                </div>
            `;

            toastContainer.appendChild(toastElement);

            // Animation hiện toast
            requestAnimationFrame(() => {
                toastElement.style.opacity = '1';
                toastElement.style.transform = 'translateX(0)';
            });

            // Xử lý nút close
            const closeBtn = toastElement.querySelector('button');
            const closeToast = () => {
                toastElement.style.opacity = '0';
                toastElement.style.transform = 'translateX(100%)';
                setTimeout(() => {
                    if (toastElement.parentNode) {
                        toastElement.remove();
                    }
                    if (toastContainer && !toastContainer.hasChildNodes()) {
                        toastContainer.style.display = "none";
                    }
                }, 300);
            };

            closeBtn?.addEventListener('click', closeToast);

            // Auto hide
            if (autohide) {
                setTimeout(closeToast, delay);
            }

            return toastElement;
        },

        // Hàm tạo link share cho scene
        // Sử dụng window.location.origin để lấy domain hiện tại (ocopnghean360.com hoặc platform.starglobal3d.com tùy theo domain đang xem)
        createSceneShareLink: (sceneName: string, lang: string = 'vn') => {
            if (typeof window === 'undefined') return '';
            
            const baseUrl = globalUtils.general.getBaseUrl();
            const shareUrl = `${baseUrl}?startscene=${sceneName}&lang=${lang}`;
            
            // Đảm bảo URL sử dụng domain hiện tại (window.location.origin)
            return shareUrl;
        },

        // Hàm tạo link share cho AutoTour
        createAutoTourShareLink: (tourId: string, lang: string = 'vn') => {
            if (typeof window === 'undefined') return '';
            
            const baseUrl = globalUtils.general.getBaseUrl();
            const shareUrl = `${baseUrl}?tab=nav_autotour&id=${tourId}&lang=${lang}`;
            
            return shareUrl;
        },

        // Hàm tạo link share cho GroupView
        createGroupViewShareLink: (id: string, type: string, lang: string = 'vn', startscene?: string) => {
            if (typeof window === 'undefined') return '';
            
            const baseUrl = globalUtils.general.getBaseUrl();
            let url = `${baseUrl}?tab=nav_group_view&id=${id}&type=${type}&lang=${lang}`;
            if (startscene) {
                url += `&startscene=${startscene}`;
            }
            return url;
        },


        // Hàm tạo link share cho Gallery (3D Model)
        createGalleryShareLink: (modelId: string, lang: string = 'vn') => {
            if (typeof window === 'undefined') return '';
            
            const baseUrl = globalUtils.general.getBaseUrl();
            return `${baseUrl}?tab=nav_gallery&id=${modelId}&lang=${lang}`;
        },

        // Hàm tạo link share cho Material Video
        createMaterialVideoShareLink: (videoId: string, lang: string = 'vn',category: string) => {
            if (typeof window === 'undefined') return '';
            
            const baseUrl = globalUtils.general.getBaseUrl();
            return `${baseUrl}?tab=nav_material&id=${videoId}&type=video&category=${category}&lang=${lang}`;
        },

        // Hàm tạo link share cho Material Album/Photo
        createMaterialAlbumShareLink: (albumId: string, lang: string = 'vn') => {
            if (typeof window === 'undefined') return '';
            
            const baseUrl = globalUtils.general.getBaseUrl();
            return `${baseUrl}?tab=nav_material&id=${albumId}&type=album&lang=${lang}`;
        },

        // Hàm tạo link share cho Material Document
        createMaterialDocumentShareLink: (documentId: string, lang: string = 'vn') => {
            if (typeof window === 'undefined') return '';
            
            const baseUrl = globalUtils.general.getBaseUrl();
            return `${baseUrl}?tab=nav_material&id=${documentId}&type=document&lang=${lang}`;
        },

        // Hàm tạo link share cho Material (Video, Album, Document)
        createMaterialShareLink: (
            id: string,
            // type: 'video' | 'album' | 'document',
            type: string,
            category_uuid: string,
            lang: string = 'vn'
            
        ) => {
            if (typeof window === 'undefined') return '';
            
            const baseUrl = globalUtils.general.getBaseUrl();
            return `${baseUrl}?tab=nav_material&id=${id}&type=${type}&category=${category_uuid}&lang=${lang}`;
        },

        // Hàm theo dõi sự kiện cho Microsoft Clarity
        trackClarity: (eventName: string, data?: any) => {
            if (typeof window !== 'undefined' && (window as any).clarity) {
                (window as any).clarity("event", eventName, data);
            }
        },
    },
};
